import { Currency } from '../types/enums/Currency';
import { numericUtils } from './numeric.utils';
import { stringUtils } from './string.utils';

export const moneyUtils = {
    roundToMillions,
    amountToMM,
    money,
    parse,
    getCurrencySymbol,
};

function roundToMillions(value: number, precision: number) {
    const amount = Number(value);
    return numericUtils.round(Math.abs(Math.trunc(amount) / 1.0e+6), precision).toFixed(precision);
}

function amountToMM(amountRaw: number, showMM = false, decimalPlaces = 3) {
    if (numericUtils.isNumber(amountRaw)) {
        const millions = Number(roundToMillions(amountRaw, decimalPlaces));
        const billionSeparatedValue = money(millions, decimalPlaces > 0, decimalPlaces);

        return showMM ? `${billionSeparatedValue}MM` : billionSeparatedValue;
    }

    return '';
}

function getCurrencySymbol(currencyCode?: Currency) {
    if (!currencyCode) {
        return '';
    }

    return currencyCode === Currency.USD ? '$' : '€';
}

function money(value: number, addDecimalPlaces = false, decimalPlaces = 2) {
    if (numericUtils.isNumber(value)) {
        const number = Number(value);

        if (addDecimalPlaces) {
            return numericUtils
                .round(number, decimalPlaces)
                .toLocaleString(
                    'en-US', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                })
        }

        return numericUtils.round(number).toLocaleString('en-US');
    }

    return '';
}

function parse(value?: string | null) {
    return stringUtils.isNullOrWhiteSpace(value)
        ? NaN
        : numericUtils.numberOrDefault(String(value).replace(/,/g, ''), NaN);
}
